export const expiredCheckoutUrgencyModalTextsControl = {
  headingText: 'Your session has expired',
  bodyText: 'Go back to the menu to check your recipes are still in stock',
  ctaText: 'Back to the menu',
}

export const almostExpiredCheckoutUrgencyModalTextsControl = {
  headingText: 'Your session is about to expire',
  bodyText: 'Continue with checkout to avoid losing your recipes',
  ctaText: 'Continue with checkout',
}

export const expiredCheckoutUrgencyModalTextsTreatment = {
  headingText: 'Your session has expired',
  bodyText: 'Go back to the menu to check your recipes are still in stock',
  ctaText: 'Return to menu',
}

export const almostExpiredCheckoutUrgencyModalTextsTreatment = {
  headingText: 'Your session is about to expire',
  bodyText: 'Continue to checkout to secure the recipes in your box',
  ctaText: 'Checkout',
}
